<ion-content [fullscreen]="true">
  <!-- <div id="chat-container" [style.--background-color]="randColor">
    <app-chat-modal></app-chat-modal>
  </div> -->
  @if (quizzes().length !== 0) {
    <app-moodle-quiz [quizzes]="quizzes()" btnTxt="Finir l'évaluation"></app-moodle-quiz>
  }
</ion-content>
